import React from 'react';
import _ from 'lodash';

export default function PageHeader(props) {
    const styles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
        marginTop: '0px',
        border: 0,
        paddingLeft: '15px',
    };

    return (
        <div style={{ ...styles, ...props.style }}>
            <div>
                <h3>{props.title}</h3>
                {
                    !_.isEmpty(props.subTitle) && <h5 style={{ lineHeight: '0.3em' }}>{props.subTitle}</h5>
                }
            </div>
            {props.children}
        </div>
    );
}
